
import { createTheme } from '@mui/material/styles';
import { colorTheme } from './constants';

const muiTheme = createTheme({
  typography: {
    fontFamily: "'Inter', sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none'
        }
      }
    },
    MuiAlert: {
      styleOverrides: {
        filledSuccess: {
          backgroundColor: colorTheme.light.success
        },
        filledError: {
          backgroundColor: colorTheme.light.error
        }
      }
    }
  }
});


export default muiTheme;
